import BaseController from './BaseController';
import { isStorageAvailable } from '../helpers/Util';
import AppConfig from '../appConfig';
import { HelpTourNewUserSteps, HelpTourExistingUserSteps, HelpTourVersions } from '../enums/HelpTourDefinitions'

const STORAGE = window.localStorage;
const IS_STORAGE_AVAILABLE = isStorageAvailable(STORAGE);
const HELP_TOUR_STORAGE_KEY = `${AppConfig.constants.environment}-${AppConfig.constants.helpTourCompletedFlagName}`;
const HELP_TOUR_VERSION_STORAGE_KEY = `${AppConfig.constants.environment}-${AppConfig.constants.helpTourVersionFlagName}`;
const CURRENT_TOUR_VERSION = HelpTourVersions.V2;

class HelpController extends BaseController {
    static get name() {
        return 'HelpController';
    }

    static getInstance(options) {
        return new HelpController(options);
    }

    onActivate() {
        this.bindGluBusEvents({
            HELP_TOUR_STATUS_REQUEST: this.onHelpTourStatusRequest,
            HELP_TOUR_STATUS_UPDATE_REQUEST: this.onHelpTourStatusUpdateRequest,
        });
        this.isHelpTourDone = undefined;
        this.tourVersion = undefined;
    }

    onHelpTourStatusRequest() {
        if (this.isHelpTourDone === undefined && IS_STORAGE_AVAILABLE) {
            this.isHelpTourDone = STORAGE.getItem(HELP_TOUR_STORAGE_KEY) === 'true';
            this.tourVersion = STORAGE.getItem(HELP_TOUR_VERSION_STORAGE_KEY) || null;
            
            this.bus.emit('HELP_TOUR_STATUS_UPDATE_REQUEST', { 
                isDone: this.isHelpTourDone,
                tourVersion: this.tourVersion 
            });
        }

        // If helptourcompleted = false, show the new user tour
        if (this.isHelpTourDone === false) {
            this.bus.emit('HELP_TOUR_START_REQUEST', { tourSteps: HelpTourNewUserSteps });
        } 
        // If the user has completed the old tour but not the new one, show the new tour (v2)
        else if (this.isHelpTourDone === true && this.tourVersion !== CURRENT_TOUR_VERSION) {
            this.bus.emit('HELP_TOUR_START_REQUEST', { tourSteps: HelpTourExistingUserSteps });
        }
        // If the user has completed v2, do not show any tour (default behavior, no action needed)
    }

    onHelpTourStatusUpdateRequest(params) {
        this.isHelpTourDone = params.isDone;

        if (params.tourVersion) {
            this.tourVersion = params.tourVersion;
        }

        if (IS_STORAGE_AVAILABLE) {
            STORAGE.setItem(HELP_TOUR_STORAGE_KEY, this.isHelpTourDone);

            if (this.tourVersion) {
                STORAGE.setItem(HELP_TOUR_VERSION_STORAGE_KEY, this.tourVersion);
            }
        }
    }

    onDeactivate() {
        this.unbindGluBusEvents();
    }
}

export default HelpController;
